import {webClient} from "../../config/axios";
import {handleError} from "../handleRequestError";

export const getPasswordListRequest = (callback) => {
    webClient.get('/user/app-password')
        .then(response => {
            callback(response.data, false);
        })
        .catch(err => {
            handleError(err, callback);
        })
};